export default "__VITE_ASSET__BLjfQ_pA__"